export const STATUS_KEEP = 'keep'
export const STATUS_CREATE = 'create'
export const STATUS_UPDATE = 'update'
export const STATUS_DELETE = 'delete'

export const SURVEY_CATEGORIES = {
    Leadership: {
        teamBuilder: {
            display: 'Team Builder',
            left: 'Weak',
            right: 'Strong',
        },
        leadership: {
            display: 'Leadership',
            left: 'Weak',
            right: 'Strong',
        },
        strategist: {
            display: 'Strategist',
            left: 'Weak',
            right: 'Strong',
        },
        mergersAndAcquisitions: {
            display: 'M&A',
            left: 'Aggressive',
            right: 'Disciplined',
        },
    },
    'Fit for CEO Role and Attributes': {
        fitForCeoRole: {
            display: 'Fit for a CEO Role',
            left: 'Low',
            right: 'High',
        },
        integrity: {
            display: 'Integrity',
            left: 'Low',
            right: 'High',
        },
        emotionalIntelligence: {
            display: 'Emotional Intelligence',
            left: 'Low',
            right: 'High',
        },
        selfAwareness: {
            display: 'Self-awareness',
            left: 'Low',
            right: 'High',
        },
    },
    'Management Style': {
        micromanagerVsHandsOff: {
            display: 'Micromanager',
            left: 'Hands-Off',
            right: 'Micromanager',
        },
        goalSetting: {
            display: 'Goal Setting',
            left: 'Conservative',
            right: 'Aggressive',
        },
        financialAcumen: {
            display: 'Financial Acumen',
            left: 'Weak',
            right: 'Strong',
        },
        deliverables: {
            display: 'Deliverables',
            left: 'Speed',
            right: 'Quality',
        },
    },
    'Communication and Personality': {
        communication: {
            display: 'Communication',
            left: 'Weak',
            right: 'Strong',
        },
        transparency: {
            display: 'Transparency',
            left: 'Low',
            right: 'High',
        },
        arrogantVsHumble: {
            display: 'Arrogant vs. Humble',
            left: 'Arrogant',
            right: 'Humble',
        },
        abrasiveVsMellow: {
            display: 'Abrasive vs. Mellow',
            left: 'Abrasive',
            right: 'Mellow',
        },
    },
}

const defaults = {}

for (let questions of Object.values(SURVEY_CATEGORIES)) {
    for (let key of Object.keys(questions)) {
        defaults[key] = 3
    }
}
